import { createIndicator } from '~/modules/SDK/indicator/createIndicator';
import { indicatorsValueStore } from '~/modules/investment-consultant/positionValueForm/indicatorsValueStore';
export const wu5868_signal_chip = createIndicator({
    displayName: '主力策略',
    id: 'wu5868-signal-chip',
    constructorScope: {
        init(context, inputCallback) {
            return;
        },
        main(context, inputCallback) {
            const marketposition = this._context.new_var();
            const entryPrice = this._context.new_var();
            const symbol = context.symbol.info?.ticker;
            const close = this.PineJS.Std.close(this._context);
            const close_array = this._context.new_var(close);
            const itime = this.PineJS.Std.time(this._context);
            const ma5 = this.PineJS.Std.sma(close_array, 5, this._context);
            const ma30 = this.PineJS.Std.sma(close_array, 30, this._context);
            const ma10 = this.PineJS.Std.sma(close_array, 10, this._context);
            const ma5_array = this._context.new_var(ma5);
            const ma30_array = this._context.new_var(ma30);
            const open = this.PineJS.Std.open(this._context);
            const volume = this.PineJS.Std.volume(this._context);
            const volume_array = this._context.new_var(volume);
            const ma_volume = this.PineJS.Std.sma(volume_array, 40, this._context);
            marketposition.get(2);
            entryPrice.get(2);
            ma5_array.get(10);
            ma30_array.get(10);
            const long = close > open &&
                close > ma5 &&
                ma5 > ma30 &&
                ma5 > ma10 &&
                volume > ma_volume &&
                ma5_array.get(0) > ma5_array.get(1) &&
                volume > 1000;
            const short = close < open &&
                close < ma5 &&
                ma5 < ma30 &&
                ma5 < ma10 &&
                volume > ma_volume &&
                ma5_array.get(0) < ma5_array.get(1) &&
                volume > 1000;
            let buy_icon = NaN;
            let short_icon = NaN;
            if (long && !symbol?.includes('-')) {
                marketposition.set(1);
            }
            if (short && !symbol?.includes('-')) {
                marketposition.set(-1);
            }
            if (marketposition.get(0) === 1 && marketposition.get(1) !== 1) {
                buy_icon = 1;
                entryPrice.set(close);
                indicatorsValueStore.openPositionProfit = 0;
                indicatorsValueStore.entryPrice = close;
                indicatorsValueStore.marketPosition = 1;
                indicatorsValueStore.entryDate = itime;
                indicatorsValueStore.multipleTargetPrice = [entryPrice * 1.1, entryPrice * 1.2];
                indicatorsValueStore.stopLossPrice = entryPrice * 0.9;
            }
            if (marketposition.get(0) === -1 && marketposition.get(1) !== -1) {
                short_icon = 1;
                entryPrice.set(close);
                indicatorsValueStore.openPositionProfit = 0;
                indicatorsValueStore.entryPrice = close;
                indicatorsValueStore.marketPosition = -1;
                indicatorsValueStore.entryDate = itime;
                indicatorsValueStore.multipleTargetPrice = [entryPrice * 0.9, entryPrice * 0.8];
                indicatorsValueStore.stopLossPrice = entryPrice * 1.1;
            }
            if (marketposition.get(0) === 1 && marketposition.get(1) === 1) {
                indicatorsValueStore.openPositionProfit = close - entryPrice.get(0);
                if ((close < entryPrice.get(0) * 0.96 &&
                    close_array.get(0) < ma5_array.get(0) &&
                    close_array.get(1) < ma5_array.get(1)) ||
                    (close_array.get(0) < ma5_array.get(0) &&
                        close_array.get(1) < ma5_array.get(1) &&
                        close < ma30)) {
                    marketposition.set(0);
                    indicatorsValueStore.marketPosition = 0;
                    indicatorsValueStore.entryDate = NaN;
                    indicatorsValueStore.entryPrice = NaN;
                }
            }
            if (marketposition.get(0) === -1 && marketposition.get(1) === -1) {
                indicatorsValueStore.openPositionProfit = entryPrice.get(0) - close;
                if ((close > entryPrice.get(0) * 1.04 &&
                    close_array.get(0) > ma5_array.get(0) &&
                    close_array.get(1) > ma5_array.get(1)) ||
                    (close_array.get(0) > ma5_array.get(0) &&
                        close_array.get(1) > ma5_array.get(1) &&
                        close > ma30)) {
                    marketposition.set(0);
                    indicatorsValueStore.marketPosition = 0;
                    indicatorsValueStore.entryDate = NaN;
                    indicatorsValueStore.entryPrice = NaN;
                }
            }
            const colorIndex = () => {
                if (marketposition.get(0) === 1)
                    return 0;
                else if (marketposition.get(0) === -1)
                    return 3;
                else
                    return 4;
            };
            return [ma5, buy_icon, short_icon, !symbol?.includes('-') ? colorIndex() : NaN];
        },
    },
    metainfo: {
        _metainfoVersion: 40,
        scriptIdPart: '',
        is_hidden_study: false,
        is_price_study: true,
        isCustomIndicator: true,
        plots: [
            { id: 'plot_0', type: 'line' },
            {
                id: 'plot_1',
                type: 'chars',
            },
            {
                id: 'plot_2',
                type: 'chars',
            },
            {
                id: '多空顏色',
                type: 'bar_colorer',
                palette: 'palette_0',
            },
        ],
        defaults: {
            styles: {
                plot_0: {
                    linestyle: 1,
                    visible: false,
                    linewidth: 1,
                    plottype: 0,
                    trackPrice: false,
                    transparency: 30,
                    color: '#5577ff',
                },
                plot_1: {
                    color: '#dd5e56',
                    textColor: '#dd5e56',
                    transparency: 0,
                    visible: true,
                },
                plot_2: {
                    color: '#52a49a',
                    textColor: '#52a49a',
                    transparency: 0,
                    visible: true,
                },
            },
        },
        styles: {
            plot_0: {
                title: '成本線',
                histogramBase: 0,
            },
            plot_1: {
                isHidden: false,
                location: 'BelowBar',
                char: '▲',
                size: 'small',
                text: '多單進場1',
                title: '多單進場',
            },
            plot_2: {
                isHidden: false,
                location: 'AboveBar',
                char: '▼',
                size: 'small',
                text: '空單進場',
                title: '多單進場',
            },
        },
        palettes: {
            palette_0: {
                colors: {
                    0: {
                        color: '#df484c',
                        width: 1,
                        style: 0,
                    },
                    1: {
                        color: '#e39e9c',
                        width: 1,
                        style: 0,
                    },
                    2: {
                        color: '#91b48a',
                        width: 1,
                        style: 0,
                    },
                    3: {
                        color: '#5cb642',
                        width: 1,
                        style: 0,
                    },
                    4: {
                        color: '#aaaaaa',
                        width: 1,
                        style: 0,
                    },
                },
            },
        },
        inputs: [],
    },
});
